import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { SalesMonthPoint } from "@/core/pharmacy/dashboard-analytics";
import { formatMoneyCompact } from "@/core/pharmacy/format";

interface MonthlySalesChartProps {
  data: SalesMonthPoint[];
}

export function MonthlySalesChart({ data }: MonthlySalesChartProps) {
  return (
    <div className="ph-chart-wrap">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#64748b" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            cursor={{ fill: "rgba(13, 148, 136, 0.06)" }}
            content={({ active, payload }) => {
              if (!active || !payload?.[0]) return null;
              return (
                <div
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #e2e8f0",
                    background: "#fff",
                    fontSize: 13,
                  }}
                >
                  <strong>{formatMoneyCompact(Number(payload[0].value))}</strong>
                  <span className="text-muted ms-1">CA mensuel</span>
                </div>
              );
            }}
          />
          <Bar dataKey="revenue" fill="#0d9488" radius={[6, 6, 0, 0]} maxBarSize={48} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
